import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import * as amplitude from 'amplitude-js';

import { throwError } from '@/utils';
import { UserDTO } from '@/api';
import services from '@/services';

@Module({ name: 'UsersModule' })
export default class UsersModule extends VuexModule {
  listLoading = false;

  list: UserDTO[] = [];

  @Mutation
  setListLoading(state: boolean) {
    this.listLoading = state;
  }

  @Mutation
  setUsers(roles: UserDTO[]) {
    this.list = roles;
  }

  @Mutation
  addUser({ model }: { model: UserDTO }) {
    const index = this.list.findIndex(user => user.id === model.id);
    if (index > -1) {
      this.list[index] = model;
    } else {
      this.list.push(model);
    }
  }

  @Action({ rawError: true })
  async fetchUsers() {
    try {
      this.setListLoading(true);
      const { data: users } = await services
        .userService()
        .userEndpointGetAllUser();
      this.setUsers(users);
      amplitude.getInstance().logEventWithGroups('Загрузка списка', users.length, 'Пользователи');
      return users;
    } catch (e) {
      return throwError('Ошибка сохранения пользователей')(e);
    } finally {
      this.setListLoading(false);
    }
  }

  @Action({ rawError: true })
  async saveUsers(users: { user: UserDTO; id?: number; password?: string; roleIds?: number[] }[]) {
    try {
      this.setListLoading(true);
      const promises = users.map(({
        user, id, password, roleIds,
      }) => services.userService()
        .userEndpointStoreUser({
          id,
          email: user.email,
          phoneNumber: user.phoneNumber,
          password,
          firstName: user.firstName,
          surname: user.surname,
          description: user.description,
          role: roleIds,
        }).then(r => r.data));
      const ids = await Promise.all(promises);
      users.forEach(({ user }, index) => {
        this.addUser({ model: { ...user, id: ids[index] } });
      });
      amplitude.getInstance().logEventWithGroups('Сохранение пользователей', users, 'Пользователи');
      return ids;
    } catch (e) {
      return throwError('Ошибка сохранения пользователей')(e);
    } finally {
      this.setListLoading(false);
    }
  }
}
